import { SEXES_OBJECT } from 'constants/variables'
import { CitizenFilterKeyString } from '../types'
import { setFilterPrefixes } from 'utils/api'

export function getCitizenFilterFeedbacks(value: string) {
  const sex = SEXES_OBJECT[value] ? SEXES_OBJECT[value] : ''

  const citizenFilterFeedbacks: CitizenFilterKeyString = setFilterPrefixes('unified_person', {
    search: `Geral: ${value}`,
    id: `ID: ${value}`,
    name: `Nome: ${value}`,
    social_name: `Nome social: ${value}`,
    mother_name: `Nome da mãe: ${value}`,
    father_name: `Nome do pai: ${value}`,
    cpf_number: `CPF: ${value}`,
    cns_number: `CNS: ${value}`,
    rg_number: `RG: ${value}`,
    ctps_pis_number: `PIS: ${value}`,
    race: `Raça: ${value}`,
    main_address_neighbourhood: `Bairro principal: ${value}`,
    health_place_name: `Unidade de saúde: ${value}`,
    school_place_name: `Unidade de educação: ${value}`,
    social_place_name: `Unidade social: ${value}`,
    gov_place_name: `Unidade do governo: ${value}`,
    jobsite_name: `Posto de trabalho: ${value}`,
    sex: `Sexo: ${sex}`,
  })

  return citizenFilterFeedbacks
}
